import {
  CUSTOMER_CLEAR,
  CUSTOMER_EDIT,
  CUSTOMER_LOAD,
  CUSTOMER_PASSWORD_CHANGE,
} from "./constants";

const initalState = { editModel: false, phoneNumberChangeModel: false };

function customerReducer(state = initalState, action) {
  switch (action.type) {
    case CUSTOMER_LOAD:
      return action.payload;
    case CUSTOMER_CLEAR:
      return initalState;
    case CUSTOMER_EDIT:
      return { ...state, editModel: !state.editModel };
    case CUSTOMER_PASSWORD_CHANGE:
      return {
        ...state,
        phoneNumberChangeModel: !state.phoneNumberChangeModel,
      };
    default:
      return state;
  }
}

export { customerReducer };
